export class ContentFooterSocial {
  iconValue: ContentSocialIcon[];

  constructor(contentjson?: any) {
    if (contentjson) {
      this.iconValue = this.fillIcon(contentjson);
    }
  }

  private fillIcon(contentjson?: any): ContentSocialIcon[] {
    let icon: ContentSocialIcon[] = [];
    const icons = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      let counter = 1;
      for (const value of values) {
        icons.set(counter, new ContentSocialIcon(counter, value));
        counter++;
      }
      icon = Array.from(icons.values());
    }
    return icon;
  }
}

export class ContentSocialIcon {
  id: any;
  iconLink: any;
  iconLogo: any;
  iconAlt: any;
  openExternalLinkModal: string;
  openinnewTab: any;

  constructor(id: any, contentjson?: any) {
    if (contentjson) {
      this.id = id;
      if (contentjson['iconLink']) {
        this.iconLink = contentjson['iconLink'];
      } else {
        this.iconLink = '';
      }
      if (contentjson['iconLogo']) {
        this.iconLogo = contentjson['iconLogo'];
      } else {
        this.iconLogo = '';
      }
      if (contentjson['iconAlt']) {
        this.iconAlt = contentjson['iconAlt'];
      } else {
        this.iconAlt = '';
      }
      if (contentjson['openExternalLinkModal']) {
        this.openExternalLinkModal = contentjson['openExternalLinkModal'];
      }
      if (contentjson['openinnewTab']) {
        this.openinnewTab = contentjson['openinnewTab'];
      } else {
        this.openinnewTab = '';
      }
    }
  }
}
